@if(sommelier){
<app-metro-profile
  [imageUrl]="imageUrl"
  [name]="sommelier.fullName"
  [role]="sommelier.certification"
  [connectedSince]="sommelier.userCreationTime | date:'yyyy'"
  [title]="'::MySommelier' | abpLocalization"
  [description]="sommelier.bio"
  [primaryButtonLabel]="'Ver Catálogo'"
  [secondaryButtonLabel]="'Contactar'"
  [onPrimaryClick]="viewCatalog.bind(this)"
  [onSecondaryClick]="contact.bind(this)"
  [linkToShare]="fullLink"
  [waHref]="whatsAppHref"
>
</app-metro-profile>
}

